module.exports = __webpack_public_path__ + "img/icon-lys.a1b94ae8.png";